import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@core/config/routes'

export const authRoutes: RouteRecordRaw[] = [
  {
    path: routes.LOGIN,
    name: 'LOGIN',
    component: () => import('./LoginPage.vue'),
    meta: { requiresGuest: true },
  },
  {
    path: routes.VERIFY_OTP,
    name: 'VERIFY_OTP',
    component: () => import('./VerifyOtpPage.vue'),
    meta: { requiresGuest: true },
  },
]
